import { ownerName } from '../../../lib/championships.js'
import { seatFor } from '../pursuit/splitFamily.js'
import {linkedCoverageMembers,matchesCoverageMember} from '../../../lib/schoolTeamOverlay.js'

const key = value => String(value ?? '').trim().toLowerCase()
export const isUnassignedScope = value => ['(unassigned)', 'unassigned'].includes(key(value))

// Display scope only. The server remains the authority for access and actions.
export function inWorklistScope(record, person, {actor = null} = {}) {
  if (!person || person === '*') return true
  if (String(person).startsWith('school-team:')) return matchesCoverageMember(record,String(person).slice(12))
  if (actor?.id && key(person) === key(actor.name) && matchesCoverageMember(record,actor.id)) return true
  if (isUnassignedScope(person)) return !ownerName(record)
  return key(ownerName(record)) === key(person) || seatFor(record, person) === 'support'
}

// No absent map entry may mean zero until the complete, healthy read is known.
export function worklistBookCounts(book = [], { complete = false, actor = null } = {}) {
  if (!complete) return null
  const out = { '*': book.length, '(unassigned)': 0 }
  for (const record of book) {
    const owner = ownerName(record)
    if (!owner) out['(unassigned)']++
    const names = new Set([owner, record?.supportRep, record?.supportRep2].map(key).filter(Boolean))
    for (const name of names) {
      if (isUnassignedScope(name) || !inWorklistScope(record, name)) continue
      out[name] = (out[name] || 0) + 1
    }
    for (const member of linkedCoverageMembers(record)) {
      const value = `school-team:${member.id}`
      out[value] = (out[value] || 0) + 1
    }
  }
  if (actor?.id && actor?.name) out[key(actor.name)] = book.filter(record => inWorklistScope(record,actor.name,{actor})).length
  out.unassigned = out['(unassigned)']
  return out
}

export function worklistPersonParams(params, person) {
  const next = new URLSearchParams(params)
  if (person) next.set('person', person)
  else next.delete('person')
  // A crown deep link belongs to the previous person's view, not this choice.
  next.delete('focus')
  return next
}
